import { render, staticRenderFns } from "./SubquestionCreation.vue?vue&type=template&id=4a18eefe&"
import script from "./SubquestionCreation.vue?vue&type=script&lang=js&"
export * from "./SubquestionCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports